import * as React from "react";
import { DryRunIssue } from "../../../services/utils";
import { mk8sDryRun } from "../../../mobxStores/dryRun/mk8s";
import NGAlert from "../../../newcomponents/alert";

export const ByokDryRunMessage: React.FC = () => {
  let issues: DryRunIssue[] = mk8sDryRun.response?.details?.issues || [];

  let filteredIssues = (issues || []).filter((i) => {
    let p = i.path;
    if (!p) {
      return false;
    }
    return p.includes(`spec.addOns.byok`);
  });

  if (filteredIssues.length < 1) {
    return null;
  }

  const issue = filteredIssues[0];

  return <NGAlert type={issue.severity === "error" ? "error" : "warning"} message={issue.message} />;
};
